import apiClient from '../utils/apiClient';

export interface SftpFileRetrievalResult {
  pbmId: number;
  pbmName: string;
  message: string;
  retrievedFiles: string[];
}

export interface ContainerFileInfo {
  fileName: string;
  containerName?: string;
  pbmId: number;
  pbmName: string;
  lastModified?: Date;
  size: number;
}

export interface ContainerFilesResponse {
  totalFiles: number;
  files: ContainerFileInfo[];
}

export const retrieveFilesByConnectionId = async (connectionId: number): Promise<SftpFileRetrievalResult> => {
  try {
    return await apiClient.post<SftpFileRetrievalResult>(`api/SftpFileRetrieval/retrieve-by-connection-id/${connectionId}`);
  } catch (error) {
    console.error('Error retrieving files from SFTP:', error);
    throw error;
  }
};

export const retrieveFilesByPbmId = async (pbmId: number): Promise<SftpFileRetrievalResult> => {
  try {
    return await apiClient.post<SftpFileRetrievalResult>(`api/SftpFileRetrieval/retrieve-by-pbm-id/${pbmId}`);
  } catch (error) {
    console.error('Error retrieving files from SFTP:', error);
    throw error;
  }
};

export const listContainerFiles = async (
  params: {
    pbmId?: number;
    pbmName?: string;
    fileNameContains?: string;
    sortOrder?: string;
    pageSize?: number;
    pageNumber?: number;
  } = {}
): Promise<ContainerFilesResponse> => {
  try {
    // Build query string from params
    const queryParams = new URLSearchParams();
    if (params.pbmId) queryParams.append('pbmId', params.pbmId.toString());
    if (params.pbmName) queryParams.append('pbmName', params.pbmName);
    if (params.fileNameContains) queryParams.append('fileNameContains', params.fileNameContains);
    if (params.sortOrder) queryParams.append('sortOrder', params.sortOrder);
    if (params.pageSize) queryParams.append('pageSize', params.pageSize.toString());
    if (params.pageNumber) queryParams.append('pageNumber', params.pageNumber.toString());

    const queryString = queryParams.toString();
    const url = `api/SftpFileRetrieval/list-container-files${queryString ? `?${queryString}` : ''}`;
    
    return await apiClient.get<ContainerFilesResponse>(url);
  } catch (error) {
    console.error('Error listing container files:', error);
    throw error;
  }
};

// Helper function to download a file from a container
export const downloadContainerFile = (containerName: string, fileName: string): void => {
  // Use the downloadFile method from apiClient
  apiClient.downloadFile(`api/SftpFileRetrieval/download-container-file?containerName=${encodeURIComponent(containerName)}&fileName=${encodeURIComponent(fileName)}`)
    .then(({ blob }) => {
      // Create a URL for the blob
      const url = window.URL.createObjectURL(blob);
      
      // Create a temporary anchor element to trigger the download
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      
      // Clean up
      window.URL.revokeObjectURL(url);
      document.body.removeChild(link);
    })
    .catch(error => {
      console.error('Error downloading file:', error);
      alert('Failed to download file. Please try again later.');
    });
};
